import styled from 'styled-components';
import { Button } from 'reactstrap';
import colors from '../../../../includes/colors';


export const Title = styled.h2`
  color: ${colors.black};
  line-height: 2.5rem;
  font-weight: 300;
  font-size: 1.5rem;
`;

export const SearchButton = styled(Button)`
  background-color: ${colors.blue} !important;
  font-size: 1rem;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  display: block;
`;
